import React from 'react';
import PropTypes from 'prop-types';
import { Container, Icon, Typography } from '@sm/wds-react';

import './endpage-header.scss';

const EndpageHeader = ({ headerColor, icon, copy }) => (
  <Container p={6} flexJustify="center" className={`sm-endpage-header sm-endpage-header--${headerColor}`}>
    <Typography align="center" component="section" variant="sectionTitle">
      <Icon className="sm-endpage-header__icon wds-display--block wds-display--md-inline wds-m-r-2">{icon}</Icon>
      <Typography
        className="sm-endpage-header__copy wds-display--inline"
        align="center"
        component="section"
        variant="sectionTitle"
      >
        <strong>{copy}</strong>
      </Typography>
    </Typography>
  </Container>
);

EndpageHeader.propTypes = {
  headerColor: PropTypes.string,
  icon: PropTypes.string,
  copy: PropTypes.string.isRequired,
};

EndpageHeader.defaultProps = {
  headerColor: 'concord',
  icon: '2',
};

export default EndpageHeader;
